var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsSlider2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 5.83333H3.125M11.4583 5.83333C11.4583 4.33697 12.6703 3.125 14.1667 3.125C15.663 3.125 16.875 4.33697 16.875 5.83333C16.875 7.32969 15.663 8.54167 14.1667 8.54167C12.6703 8.54167 11.4583 7.32969 11.4583 5.83333ZM16.875 14.1667H10.2083M10.2083 14.1667C10.2083 15.663 8.99633 16.875 7.5 16.875C6.00365 16.875 4.79167 15.663 4.79167 14.1667M10.2083 14.1667C10.2083 12.6703 8.99633 11.4583 7.5 11.4583C6.00365 11.4583 4.79167 12.6703 4.79167 14.1667M4.79167 14.1667H3.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSlider2);
export default __webpack_public_path__ + "static/media/settings_slider_2.d42f08c50c7ff9027ed64c9e0764cb80.svg";
export { ForwardRef as ReactComponent };